/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const SecurityApiEnum = {
    GET_SECURITY_ALL: (namespace: number): string => {
        return `/${namespace}/security/insights`;
    },
    GET_SECURITY_INSIGHTS_BY_ADC: (namespace: number, adcId: string): string => {
        return `/${namespace}/security/insights/${adcId}`;
    },
    GET_CERTIFICATES_ALL: (namespace: number): string => {
        return `/${namespace}/security/certificates`;
    },
    GET_CERTIFICATES_BY_ADC: (namespace: number, adcId: string): string => {
        return `/${namespace}/security/certificates/${adcId}`;
    }
};
